

































import { Component, Vue } from "vue-property-decorator";
import { ConfigModule } from "@/store/modules/config";
import { ErrorLogModule } from "@/store/modules/error-log";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";

@Component
export default class TheAdminList extends Vue {
  ActionEnum = ActionEnum;
  ResourceEnum = ResourceEnum;

  route(route: string) {
    this.$router.push({ name: route });
  }

  get isDebug() {
    return ConfigModule.debug;
  }

  toggle() {
    ConfigModule.setDebug(!ConfigModule.debug);
  }

  generateError() {
    ErrorLogModule.addErrorLog({
      name: "error",
      message: "This is an auto generated error message"
    });
  }

  get items() {
    return [
      {
        icon: "mdi-file-multiple-outline",
        text: "Partner",
        link: "/partners/list"
      },
      {
        icon: "mdi-account-outline",
        text: "User",
        link: "/user"
      },
      {
        icon: "mdi-card-account-details-outline",
        text: "Fahrzeugschein",
        link: "/fahrzeugschein"
      },
      {
        icon: "mdi-api",
        text: "API",
        link: "/api"
      }
    ];
  }
}
